// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/trip/candidates.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_proto_model_core_annotations } from "../core/annotations_pb";
import { file_proto_model_search_search_result } from "../search/search_result_pb";

/**
 * Describes the file proto/model/trip/candidates.proto.
 */
export const file_proto_model_trip_candidates = /*@__PURE__*/
  fileDesc("CiFwcm90by9tb2RlbC90cmlwL2NhbmRpZGF0ZXMucHJvdG8SBmNhcm1lbiJjChVDYW5kaWRhdGVQb29sTWV0YWRhdGESDAoEbmFtZRgBIAEoCRIgChhvcmlnaW5fY2FuZGlkYXRlX3Bvb2xfaWQYAiABKAkSGgoSb3JpZ2luX3NjaGVkdWxlX2lkGAMgASgJIuYBCglDYW5kaWRhdGUSFAoMY2FuZGlkYXRlX2lkGAEgASgJEhkKEWNhbmRpZGF0ZV9wb29sX2lkGAIgASgJEiQKBnJlc3VsdBgDIAEoCzIULmNhcm1lbi5TZWFyY2hSZXN1bHQSJwoGcmF0aW5nGAQgASgOMhcuY2FybWVuLkNhbmRpZGF0ZVJhdGluZxIrCgdjcmVhdGVkGAUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIsCghtb2RpZmllZBgGIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAioQIKDUNhbmRpZGF0ZVBvb2wSGQoRY2FuZGlkYXRlX3Bvb2xfaWQYASABKAkSDwoHdHJpcF9pZBgCIAEoCRIvCghtZXRhZGF0YRgDIAEoCzIdLmNhcm1lbi5DYW5kaWRhdGVQb29sTWV0YWRhdGESKwoHY3JlYXRlZBgEIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLAoIbW9kaWZpZWQYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEisKB2V4cGlyZXMYBiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEisKCmNhbmRpZGF0ZXMYByADKAsyES5jYXJtZW4uQ2FuZGlkYXRlQgSItRgBKo4BCg9DYW5kaWRhdGVSYXRpbmcSIAocQ0FORElEQVRFX1JBVElOR19VTlNQRUNJRklFRBAAEhwKGENBTkRJREFURV9SQVRJTkdfRElTTElLRRABEhkKFUNBTkRJREFURV9SQVRJTkdfTElLRRACEiAKHENBTkRJREFURV9SQVRJTkdfU1RST05HX0xJS0UQA0IoWiZnaXRodWIuY29tL3l1bmFjYWJhL2Nhcm1lbi9wcm90by9tb2RlbGIGcHJvdG8z", [file_google_protobuf_timestamp, file_proto_model_core_annotations, file_proto_model_search_search_result]);

/**
 * Describes the message carmen.CandidatePoolMetadata.
 * Use `create(CandidatePoolMetadataSchema)` to create a new message.
 */
export const CandidatePoolMetadataSchema = /*@__PURE__*/
  messageDesc(file_proto_model_trip_candidates, 0);

/**
 * Describes the message carmen.Candidate.
 * Use `create(CandidateSchema)` to create a new message.
 */
export const CandidateSchema = /*@__PURE__*/
  messageDesc(file_proto_model_trip_candidates, 1);

/**
 * Describes the message carmen.CandidatePool.
 * Use `create(CandidatePoolSchema)` to create a new message.
 */
export const CandidatePoolSchema = /*@__PURE__*/
  messageDesc(file_proto_model_trip_candidates, 2);

/**
 * Describes the enum carmen.CandidateRating.
 */
export const CandidateRatingSchema = /*@__PURE__*/
  enumDesc(file_proto_model_trip_candidates, 0);

/**
 * What the user thinks of a search result.
 *
 * @generated from enum carmen.CandidateRating
 */
export const CandidateRating = /*@__PURE__*/
  tsEnum(CandidateRatingSchema);

